import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=7f4ee46a&scoped=true"
import script from "./Requests.vue?vue&type=script&lang=ts"
export * from "./Requests.vue?vue&type=script&lang=ts"
import style0 from "./Requests.vue?vue&type=style&index=0&id=7f4ee46a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4ee46a",
  null
  
)

export default component.exports